<template>
  <!-- Hidden H1 for accessibility -->
  <h1 class="hidden">LVED Application</h1>

  <LayoutWrapper v-if="$route.meta.layout">
    <router-view></router-view>
  </LayoutWrapper>
  <router-view v-else></router-view>

  <!-- Global Unsaved Changes Modal -->
  <UnsavedChangesWarningModal
    :show="wishesStore.showUnsavedChangesModal"
    @confirm="wishesStore.confirmNavigation"
    @cancel="wishesStore.cancelNavigation"
  />
  <!-- Global Update Banner -->
  <transition name="fade">
  <div
    v-if="showUpdateBanner"
    class="fixed bottom-3 sm:bottom-4 left-1/2 transform -translate-x-1/2 z-[9999]
           flex flex-col sm:flex-row items-center justify-between
           gap-2 sm:gap-3 px-4 sm:px-6 py-2.5 sm:py-3
           sm:w-[60%] xs:w-[90%] w-[90%] md:min-w-[480px] lg:min-w-[520px]
          sm:max-w-fit
           text-[#1f5d6c] font-just-sans shadow-lg border border-white/10
           rounded-2xl sm:rounded-full
           bg-gradient-to-r from-[#8BEAFF] to-[#EF0]
           animate-slide-up"
  >
    <div class="flex items-center gap-[8px] sm:gap-3 text-center sm:text-left">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-4 h-4 sm:w-5 sm:h-5 text-[#1f5d6c] shrink-0"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M13 16h-1v-4h-1m1-4h.01M12 20a8 8 0 100-16 8 8 0 000 16z"
        />
      </svg>
      <span
        class="font-medium text-sm sm:text-base md:text-[15px] leading-tight w-fit"
      >
        {{ $t('commonLabels.newVersionAvailable') }}
      </span>
    </div>

    <button
      @click="refreshApp"
      class="bg-white text-[#05a8f4] font-semibold rounded-lg sm:rounded-full
             px-3 sm:px-5 py-1.5 text-xs sm:text-sm md:text-base
             hover:bg-[#E6F9FF] transition-all duration-200 shadow-sm
             whitespace-nowrap"
    >
      {{ $t('commonLabels.refresh') }}
    </button>
  </div>
</transition>
</template>

<script setup>
import LayoutWrapper from "./layout/LayoutWrapper.vue";
import { useWishesStore } from "@/stores/wishesStore";
import { onMounted, onUnmounted, ref } from "vue";
import { useUserStore } from "./stores/userStore";
import { useRolesStore } from "./stores/rolesStore";
import { useTokenRefresh } from "@/composables/useTokenRefresh";
const wishesStore = useWishesStore();
const userStore = useUserStore();
const rolesStore = useRolesStore();
const showUpdateBanner = ref(false);
let tokenRefreshFunctions = null;

onMounted(async () => {
  if (userStore.isIncapacited == "incapacitated") {
    rolesStore.showDisputeDialog = true;
    await userStore.logout();
  }
  
  if (userStore.refreshToken) {
    tokenRefreshFunctions = useTokenRefresh();
    await tokenRefreshFunctions.startTokenRefresh();
  }
  
  window.addEventListener("app-version-outdated", handleVersionOutdated);
});

onUnmounted(() => {
  if (tokenRefreshFunctions) {
    tokenRefreshFunctions.stopTokenRefresh();
  }
  window.removeEventListener("app-version-outdated", handleVersionOutdated);
});

function handleVersionOutdated() {
  showUpdateBanner.value = true;
}

function refreshApp() {
  fetch(window.location.href, { cache: "reload" })
    .then(() => {
      window.location.reload();
    })
    .catch(() => {
      window.location.reload();
    });
}
</script>

<style scoped>


.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

@keyframes slide-up {
  from {
    transform: translate(-50%, 20px);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
}

.animate-slide-up {
  animation: slide-up 0.4s ease-out;
}

.font-just-sans {
  font-family: "JUST Sans", sans-serif;
}
</style>
